import { BreadcrumbItem } from 'farmhub-ui-core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  .ant-skeleton.ant-skeleton-element {
    .ant-skeleton-input.ant-skeleton-input-sm {
      transform: translate(0, 2px);
    }
  }
`;

export const CBreadcrumbItem = styled(BreadcrumbItem)<{ hasRoute: boolean }>`
  ${props =>
    props.hasRoute &&
    `
    cursor: pointer;
    color: ${props.theme.colors.text.primary};
    
    &:hover {
      color: ${props.theme.colors.primary.main};
    }
  `}
`;
